import { render } from "./quiz-module.vue?vue&type=template&id=45fe6beb"
import script from "./quiz-module.vue?vue&type=script&lang=js"
export * from "./quiz-module.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__